{
  "version": 1,
  "asset_id": "75dc154b-9ad9-47a3-a87a-bf3780992d80",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/75dc154b-9ad9-47a3-a87a-bf3780992d80/bypass-revision-oversized-pouch-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/75dc154b-9ad9-47a3-a87a-bf3780992d80/bypass-revision-oversized-pouch-es-1200.webp",
  "original_filename": "bypass-revision-oversized-pouch-es-1200.webp",
  "size": 76916,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:21Z"
}
